export const CONFIG = {
    apiBaseUrl: 'https://pandanotify.com/api',
    cognitoLoginUrl: 'https://pandanotify.com/login',
    cognitoLogoutUrl: 'https://pandanotify.com/logout',
  };